import { mapGetters } from 'vuex';
import mvtPopSignin from '@/common/components/mvtpopsignin/mvt-popsignin.vue';
import mvtWelcome from '@/common/components/mvtwelcome/mvt-welcome.vue';
import agentInputGeo from '@/agent/components/agentInputgeo/agent-inputgeo.vue';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';

export default {
    name: 'pageAgentMeetAgents',
    inject: ['$eventBus'],
    components: {
        mvtPopSignin,
        mvtWelcome,
        agentInputGeo,
        mvtDialogCenter,
        mvtHeader,
        mvtFooter,
    },
    computed: {
        ...mapGetters('glb', ['glb']),
    },
};
